import { Component } from '@angular/core';
import { Router } from '@angular/router';
@Component({
    selector: 'app-verification-code-component',
    templateUrl: './verification-code.component.html',
    styleUrls: ['./verification-code.component.scss'],
})
export class VerificationCodeComponent {

    step = 'verify-code';
    isChangeCode: boolean = false;
    constructor(
        protected router: Router,
    //    private _snackBar: MatSnackBar
    ) {}


  // this called every time when user changed the code
//   onCodeChanged() {
//     this.isChangeCode  = true;
//   }

  // this called only if user entered full code
//   onCodeCompleted(code: string) {
//    this.user.code = code;
//   }


//   public confirmSignUp(__form: NgForm): void {
//     this.isChangeCode  = true;
//     if(this.user.code?.length == 6){
//       this.ngxService.start();
//       this.cognitoService.confirmSignUp(this.user)
//       .then(() => {
//         this.step = 'sign-up-success';
//         this.ngxService.stop();
//       }).catch((error) => {
//         this._snackBar.open(error.message, 'x', {
//           horizontalPosition: 'right',
//           verticalPosition: 'top',
//           panelClass: ['notif-error'],
//           duration: 2000
//         });
//         this.ngxService.stop();
//       });
//     }

//   }

    public async gotoDashboard(): Promise<void> {
        // this.ngxService.start();
        // console.log(this.user)
        this.router.navigate(['/dashboard']);
        // this.ngxService.stop();
    }
}
